import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import Navbar from "./components/navbar/Navbar";
import {setMain, setAuth } from './slices/menu/MenuSlice';
import {SetLogin, setName, setPermissions} from './slices/user/UserSlice';
import {setServer, setAuthTime} from './slices/app/AppSlice';
import {setUnit, setClient, setMarkings, setKodfito, setPreinfoStates} from "./slices/voc/VocSlice";
import { delError } from "./slices/error/ErrorSlice";
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios';
import MasterRoute from "./route/MasterRoute";
import { setError } from "./slices/error/ErrorSlice";
import Error from "./components/elements/Error";
import { useLocation, useNavigate } from "react-router-dom";
import {delDined} from "./slices/error/AccessSlice";
import {ColorRing} from "react-loader-spinner";

function App() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const login = useSelector((state) => state.user.login)
    const [isLoaded, setLoaded] = useState(false);


    useEffect(() => {
        if (login && location.pathname === '/') navigate('/view');
    })

    useEffect(()=>{
        axios.post(`/api/menu`)
            .then(res=>{
                dispatch(setMain(res.data.menu.main));
                dispatch(setAuth(res.data.menu.auth));
                dispatch(SetLogin(res.data.login));
                dispatch(setName(res.data.username));
                dispatch(setPermissions(res.data.permissions));
                dispatch(setServer(String(res.data.server).charAt(0).toUpperCase() + String(res.data.server).slice(1)));
                dispatch(setAuthTime(Number(res.data.auth_time)));
                // console.log(res.data);
                setLoaded(true);

                if (!res.data.login && location.pathname !== '/') {
                    navigate('/')
                } else if (res.data.login && location.pathname === '/') navigate('/view');
            })
            .catch(e=>{
                dispatch(setError(e.response.data));
            })
    }, [login])

    useEffect(() => {
        dispatch(delError());
        dispatch(delDined());
    }, [location]);

    useEffect(() => {
        axios.get('/api/unit-list')
            .then(res => {
                dispatch(setUnit(res.data))
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
        axios.get('/api/client-list')
            .then(res => {
                dispatch(setClient(res.data))
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
        axios.get('/api/markings-list')
            .then(res => {
                dispatch(setMarkings(res.data));
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
        axios.get('/api/kodfito-list')
            .then(res => {
                dispatch(setKodfito(res.data));
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
        axios.get('/api/preinfo-state-list')
            .then(res => {
                dispatch(setPreinfoStates(res.data));
            })
            .catch(e => {
                dispatch(setError(e.response.data));
            })
    }, [login])

      return (
        <div className="App" id="App">
          <header>
              <Navbar/>
          </header>
            <div className='loader'>
                <ColorRing
                    visible={! isLoaded}
                    height="80"
                    width="80"
                    ariaLabel="color-ring-loading"
                    wrapperStyle={{}}
                    wrapperClass="color-ring-wrapper"
                    colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                />
            </div>
            {isLoaded &&
              <main>
                  <Error />
                  <div id='modal-container'></div>
                  <MasterRoute/>
              </main>
            }
        </div>
      );
}

export default App;
